/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { attributes } = props;
	const { layout, columnSize, className, align, blockClientId, hideButtons } = attributes;

	const wrapperClasses = classnames(
		className,
		`align${ align }`,
		`gutenify-service-block-wrapper gutenify-service-${ layout }`,
		`gutenify-service-col-${ columnSize }`,
		hideButtons ? 'gutenify--service--hide-button' : '',
		`gutenify-section-${ blockClientId }`,
	);
	return (
		<div className={ wrapperClasses } data-section={ `gutenify-section-${ blockClientId }` }>
			<div className="gutenify-service-block">
				<InnerBlocks.Content />
			</div>
		</div>

	);
}

